export default "__VITE_ASSET__685f7b8f__"